import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { View } from '@ds'

import styles from './DesktopStub.module.scss'

export const DesktopStub = () => {
  const { t } = useTranslation()
  return (
    <View fadeIn className={styles.container}>
      <div className={styles.wrapper}>
        <div className={classNames(styles.animatedText, styles.title)}>
          {t('desktopStub.title')}
        </div>
        <div className={classNames(styles.animatedText, styles.description)}>
          {t('desktopStub.description')}
        </div>
      </div>
    </View>
  )
}
